import { createBLAKE3 } from 'hash-wasm';

/**
 * Stream a `File` through BLAKE3 and return the lowercase-hex digest (64 chars — the backend's
 * `contentBlake3` dedup key). Reads in fixed slices so a multi-GB video is never fully buffered.
 * `onProgress` reports cumulative bytes hashed (drives the "hashing" phase in the transfer row).
 */
export async function blake3File(
  file: File,
  onProgress?: (bytesHashed: number) => void,
): Promise<string> {
  const hasher = await createBLAKE3();
  hasher.init();
  const CHUNK = 8 * 1024 * 1024;
  let offset = 0;
  while (offset < file.size) {
    const end = Math.min(offset + CHUNK, file.size);
    const buf = new Uint8Array(await file.slice(offset, end).arrayBuffer());
    hasher.update(buf);
    offset = end;
    onProgress?.(offset);
  }
  return hasher.digest('hex');
}
